import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './W_CapsulesEmptyState.module.css';
import A_ContentEmpty from '@/assets/images/A_ContentEmpty.png';
import cn from 'classnames';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { PATHS } from '@/constants/paths';

interface W_CapsulesEmptyStateProps {
  message?: string;
  translationKey?: string;
  hasButton?: boolean;
}

export default function W_CapsulesEmptyState({
  message,
  translationKey = 'myCapsules.noCapsules',
  hasButton = false,
}: W_CapsulesEmptyStateProps) {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const t = (key: string) => getTranslation(language, key);

  const displayMessage = message || t(translationKey) || 'Капсул пока нет';

  return (
    <div className={styles.wrapper}>
      <img src={A_ContentEmpty} alt='Empty capsules' className={styles.image} />
      {hasButton && (
        <A_Button
          variant='primary'
          icon={
            <Q_Icon.StarIcon
              width={24}
              height={24}
              fill='white'
              stroke='white'
            />
          }
          fontSize='text-p-4'
          showIcon={true}
          size='small'
          onClick={() => navigate(PATHS.CAPSULE_CREATE)}
        >
          {t('capsulesEmptyState.createButton')}
        </A_Button>
      )}
      <p className={cn(styles.text, 'text-p-2')}>{displayMessage}</p>
    </div>
  );
}
